import * as yup from 'yup';
import { AnyObject, Maybe } from 'yup/lib/types';
import { MixedLocale } from 'yup/lib/locale';
import { RequiredNumberSchema } from 'yup/lib/number';

/**
 * Change default validation messages
 */

// To know the supported keys, check this link:
// https://github.com/jquense/yup/blob/master/src/locale.ts

yup.setLocale({
  mixed: {
    default: 'Invalid value',
    notType: 'Invalid value',
    required: 'Required field',
    defined: 'Required field',
  },
});

/**
 * Add 'safe' & 'safeRequired' methods to number schema
 */

declare module 'yup' {
  interface NumberSchema<TType extends Maybe<number> = number | undefined, TContext extends AnyObject = AnyObject, TOut extends TType = TType> {
    // Consider null/NaN values/empty strings as undefined
    safe(): RequiredNumberSchema<TType, TContext>;
    // Mark the field as required considering null/NaN values/empty strings as undefined
    safeRequired(msg?: MixedLocale['required']): RequiredNumberSchema<TType, TContext>;
  }
}

yup.addMethod(yup.number, 'safe', function safe() {
  return this.transform((value, originalValue) => {
    // eslint-disable-next-line no-restricted-globals
    return isNaN(value) || value === null || value === '' ? undefined : value;
  });
});

yup.addMethod(yup.number, 'safeRequired', function safeRequired(msg) {
  return this.safe().required(msg);
});
